import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const TickerTextEditor = ({text, tickerStyle, isEditing, onDoubleClick, onChange}) =>
  isEditing ? (
    <div className="transparent-checkerboard-pattern ticker-edit">
      <textarea style={tickerStyle}
                value={text}
                onChange={(e) => onChange(e.currentTarget.value)}/>
    </div>
  ) : (
    <div className="transparent-checkerboard-pattern ticker-view" style={tickerStyle}
         onDoubleClick={onDoubleClick}>
      <span className="ticker">{text}</span>
    </div>
  );

TickerTextEditor.propTypes = {
  text: PropTypes.string.isRequired,
  tickerStyle: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onDoubleClick: PropTypes.func,
  onChange: PropTypes.func.isRequired,

};

export default TickerTextEditor;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerTextEditor/index.js